/**
 * i18n的配置
 */
const Vue = require("vue");
import VueI18n from "vue-i18n";
const axios = require("axios");

/**
 * 生成i18n实例
 * message为本地语言包，需懒加载
 */
const i18n = new VueI18n({
  locale: "en-US", //默认语言为英文
  fallbackLocale: "en-US", //默认备用语言为英文
  messages: {},
  silentTranslationWarn: true //不显示翻译错误
});

let loadedLanguages: string[] = []; //已加载的i18n文件
const langLibrary: string[] = ["zh-CN", "en-US", "zh-HK", "ja-JP"]; //所有的支持语言

/**
 * 设置当前i18n语言
 */
const setI18nLanguage = function(lang: string): string {
  i18n.locale = lang; //设置当前的语言
  axios.defaults.headers.common["Accept-Language"] = lang; //设置请求头
  //设置文档语言
  const htmlTag: HTMLHtmlElement | null = document.querySelector("html");
  htmlTag !== null && htmlTag.setAttribute("lang", lang);
  localStorage.setItem("lang", lang); //缓存语言
  return lang;
};

const loadLanguageAsync = function(lang: string) {
  //如果已有当前语言
  lang = langLibrary.includes(lang) ? lang : "en-US";
  //如果语言相同
  if (i18n.locale === lang && loadedLanguages.length !== 0) {
    return Promise.resolve(setI18nLanguage(lang));
  }
  //如果语言已存在
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }
  //如果语言没有加载
  return axios
    .get(`/api/app/getLang?lang=${lang}`)
    .then((response: any) => {
      i18n.setLocaleMessage(lang, response.data.data); //融合语言包
      loadedLanguages.push(lang);
      return setI18nLanguage(lang);
    })
    .catch((error: any) => {
      alert("unable to read language file, please try later");
      console.log(error);
    });
};

const initLanguageAsync = function() {
  let userLanguage: string =
    localStorage.getItem("lang") || window.navigator.language;
  return loadLanguageAsync(userLanguage);
};

const translateLanguage = function(str: string, lang = undefined) {
  if (lang === undefined) return i18n.te(str) ? i18n.t(str) : "";
  else return i18n.te(str, lang) ? i18n.t(str, lang) : "";
};

//挂载

Vue.prototype.$lang = {
  init: initLanguageAsync,
  set: loadLanguageAsync,
  t: translateLanguage
};
